import { Component, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { OAuthState } from 'se-fe-auth-support'

@Component({
  selector: 'app-oauth-callback',
  template: `<se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>`,
  styles: [],
  standalone: false,
})
export class OAuthCallbackComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) { }

  public ngOnInit(): void {
    const state = OAuthState.load()
    const queryParams = this.route.snapshot.queryParamMap

    if (!state.returnTo || state.state !== queryParams.get('state')) {
      this.router.navigateByUrl('user')
      return
    }

    this.router.navigateByUrl(state.returnTo)
  }

}
